import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNavActivityBtn = _resolveComponent("AppNavActivityBtn")!
  const _component_AppNavAccountBtn = _resolveComponent("AppNavAccountBtn")!
  const _component_WalletIcon = _resolveComponent("WalletIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.account)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_AppNavActivityBtn),
          _createVNode(_component_AppNavAccountBtn)
        ]))
      : (_openBlock(), _createBlock(_component_BalBtn, {
          key: 1,
          color: "custom-blue-50",
          size: _ctx.upToLargeBreakpoint ? 'md' : 'sm',
          onClick: _ctx.toggleWalletSelectModal,
          changeType: "setting"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_WalletIcon, { class: "mr-2" }),
            _createElementVNode("span", {
              class: "hidden lg:inline-block",
              textContent: _toDisplayString(_ctx.$t('connectWallet'))
            }, null, 8, _hoisted_2),
            _createElementVNode("span", {
              class: "lg:hidden",
              textContent: _toDisplayString(_ctx.$t('connect'))
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["size", "onClick"]))
  ]))
}